import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SntDialog from "../../../components/SntDialog/SntDialog";
import SntCheckBox from "@cleanup/components/SntCheckBox/SntCheckBox";
import ReactHtmlParser from "react-html-parser";
import commonClient from "../../../apis/commonClient";
import * as actions from "../../../redux/actions";

const TermOfUse = ({ isShow, setIsShow, loginInfo }) => {
  const language = useSelector((state) => state.language);

  const dispatch = useDispatch();
  const [title, setTitle] = useState(
    language.v41_title_terms_and_conditions_and_privacy_policies_key
  );
  const [content, setContent] = useState(
    language.v41_content_transit_terms_of_use_key
  );
  const [agree, setAgree] = useState(null);
  const [agreeInfo, setAgreeInfo] = useState(
    language.v41_info_agree_terms_and_conditions_key
  );
  const [userAgree, setUserAgree] = useState(false);

  useEffect(() => {
    let termsOfUseInfo = loginInfo.termsOfUseInfo;
    if (termsOfUseInfo) {
      setAgree(
        language?.v41_agree_terms_and_conditions_key?.replace(
          "{}",
          termsOfUseInfo.url
        )
      );
      if (termsOfUseInfo.state === "NEW") {
        setTitle(
          language.v41_title_terms_and_conditions_and_privacy_policies_key
        );
        setContent(language.v41_content_never_signed_tou_key);
      } else if (termsOfUseInfo.state === "UPDATE") {
        setTitle(language.v41_title_update_terms_of_use_key);
        setContent(language.v41_content_update_terms_of_use_key);
        setAgree(
          <span style={{ textTransform: "uppercase" }}>
            {language?.v41_agree_update_terms_of_use_key?.replace(
              "{}",
              termsOfUseInfo.url
            )}
          </span>
        );
        setAgreeInfo("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginInfo]);

  function onAccept() {
    commonClient.signToU().then(() => {
      loginInfo.termsOfUseInfo.state = "OK";
      loginInfo.termsOfUseInfo.ok = true;
      dispatch(actions.updateProfile(loginInfo));
      setIsShow(false);
    });
  }

  const mainContent = useMemo(() => {
    return (
      <>
        <div>{content}</div>
        <div className="col-xs-12" style={{ display: "flex" }}>
          <SntCheckBox checked={userAgree} onChange={(e) => setUserAgree(e)} />
          <div style={{ paddingLeft: "7px", paddingTop: "9px" }}>
            <div>{ReactHtmlParser(agree)}</div>
            <div className="small-info">{agreeInfo}</div>
            <label
              id="termsConditions"
              style={{
                display: "none",
                color: "#f68484",
              }}
            >
              {language.v41_valid_accept_terms_of_use_key}
            </label>
          </div>
        </div>
      </>
    );
    // eslint-disable-next-line
  }, [isShow, userAgree, agree, agreeInfo, content]);

  return (
    <SntDialog
      isShow={isShow}
      onSave={() => onAccept()}
      isShowCloseButton={false}
      saveTxt={language.v41_accept_key}
      isShowSaveButton={true}
      title={title}
      width="35%"
    >
      {() => mainContent}
    </SntDialog>
  );
};

export default TermOfUse;
